<template>
  <div>
   
  </div>
</template>

<script>
export default {
  name: 'HomeMain'
}
</script>

<style scoped>

main {
  padding: 50px 0;
  display: flex !important;
  align-items: center;
}

.flex-auto {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
}

.flex-shrink {
  flex: 0 1 auto;
}

.container-type-documents {
  background-color: #00ACEC;
  border-radius: 25px;
  width: 100%;
  max-width: 224px;
  min-height: 212px;
  padding: 30px 28px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.container-type-documents-text span {
  font-family: "Effra Heavy", sans-serif;
  font-size: 25px;
  color: #FFFFFF;
  line-height: 1;
}

@media (max-width: 767px) {
  .container-type-documents {
    max-width: 145px;
    height: 140px;
    min-height: unset;
  }

  .container-type-documents-img img {
    max-width: 56px !important;
  }

  .container-type-documents-text span {
    font-size: 16px;
  }

  .container-type-documents {
    padding: 15px;
  }
}

@media (max-width: 1199px) {
  .container-type-documents-text {
    margin-left: unset;
    text-align: center;
  }
}
</style>